// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kix7","colMin":"styles_colMin__3V5U-"};